import React from "react"

import PropTypes from "prop-types"

import Seo from "../components/head"
import Layout from "../components/layout"
import SubscribeAll from "../components/organisms/subscribe-all"

const SubscribePage = ({ pageContext }) => (
  <Layout>
    <SubscribeAll alt={pageContext.alt} />
  </Layout>
)

export default SubscribePage

const HeadComponent = ({ location }) => (
  <Seo title="Subscribe" path={location.pathname} />
)

HeadComponent.propTypes = {
  location: PropTypes.object.isRequired,
}

export const Head = HeadComponent

SubscribePage.propTypes = {
  pageContext: PropTypes.object.isRequired,
}
